import { connected, withErrorBoundary, NoResults} from 'shared'
import { TopLevelPage } from 'ui'
import ParkCard from 'ui/parks/ParkCard'
import { ParkApi } from 'api'
import { DateRangePicker } from 'react-date-range';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';

let calendarGlobal = [];
let intervalId = null;

const AdminPlacesCalender = ({ match }) => {
  const feedItemId = match.params.id;

  const [calendar, setCalendar] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [adminPlaces, setAdminPlaces] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const parseDate = (dateTime) => format(dateTime, "yyyy-MM-dd");

  const dateParams = (calendar) => ({
    start_date: parseDate(calendar.startDate),
    end_date: parseDate(calendar.endDate),
  });

  const loadData = (calendarOverride = null) => {
    const cal = calendarOverride || { startDate: new Date(), endDate: new Date() };
    ParkApi.adminPlaces(dateParams(cal)).then((data) => {
      setAdminPlaces(data);
    });
  };

  const updateDateRange = (range) => {
    setSelectedDate(range.selection.startDate);
    setCalendar([range.selection]);
  };

  useEffect(() => {
    calendarGlobal = calendar;
    loadData(calendarGlobal[0]);

    if (intervalId) clearInterval(intervalId);

    intervalId = setInterval(() => {
      loadData(calendarGlobal[0]);
    }, 5 * 60 * 1000);

    // No cleanup function required
  }, [calendar]);

  return (
    <TopLevelPage className="AdminPlacesCalender" modelId={feedItemId} base="/admin-places-calendar">
      <div className="row calendar-section justify-content-center mt-3">
        <div className="col text-center">
          <DateRangePicker
            onChange={updateDateRange}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={[{ startDate: selectedDate, endDate: selectedDate, key: 'selection' }]}
            direction="horizontal"
            inputRanges={[]}
            editableDateInputs={false}
          />
        </div>
      </div>

      <section>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <h1 className="section-heading-lowercase my-3">Admin Community Reservations</h1>
          </div>
        </div>

        <div className="row">
          {adminPlaces.length === 0 ? (
            <NoResults>All reservable amenities are currently reserved for today.</NoResults>
          ) : (
            adminPlaces.map((model) => (
              <div className="col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                <ParkCard park={model} base="/admin-places-calendar" selectedDate={format(selectedDate, "yyyy-MM-dd")} />
              </div>
            ))
          )}
        </div>
      </section>
    </TopLevelPage>
  );
};

export default withErrorBoundary(connected(AdminPlacesCalender));
